module.exports = __webpack_public_path__ + "img/06.6f6175cc.png";